const config = {
  HOST: 'https://cryptopro.ru/',
  STATIC: 'https://cryptopro.ru/static/',
  THEME: 'https://cryptopro.ru/static/theme/60/', // Номер версии будущей темы и путь, который будет прописан в адресах
  DEVMODE: WEBPACK_APP_ENV !== 'production', // При разработке поставить TRUE, при конечной сборке FALSE (влияет на выставление путей к файлам)
  integrate: ['isIE'], // Запуск в процессе создания DOM, позволяет использовать document.write
  autorun: ['mobileCol', 'quicktabs', 'quicktabsHeader', 'lightbox', 'collapsetext', 'embedBuyForm', 'cspFastButton'] // Запуск скриптов после готовности DOM
}
export default config
